import { createStyles } from 'antd-style';
export var useStyles = createStyles(function (_ref) {
  var token = _ref.token;
  return {
    item: {
      '&:hover': {
        opacity: '0.8'
      },
      height: '32px',
      padding: '5px 8px',
      backgroundColor: '#F5F7FA',
      margin: '4px 0',
      color: '#4A4C4F',
      display: 'flex',
      alignItems: 'center',
      gap: 8
    }
  };
});